export default {
    blocked_routes: [],
    loading: false,
    poll_handle: null,
}
